export const AURORA_COLOR_STOPS = ["#4033e6", "#3477ff", "#a551f5"] as const;

function hexToRgb(hex: string): { r: number; g: number; b: number } {
    const normalized = hex.replace("#", "");
    const value =
        normalized.length === 3
            ? normalized
                  .split("")
                  .map((part) => part + part)
                  .join("")
            : normalized;

    const r = Number.parseInt(value.slice(0, 2), 16);
    const g = Number.parseInt(value.slice(2, 4), 16);
    const b = Number.parseInt(value.slice(4, 6), 16);

    return { r, g, b };
}

function rgbToHsl(
    r: number,
    g: number,
    b: number,
): { h: number; s: number; l: number } {
    const rn = r / 255;
    const gn = g / 255;
    const bn = b / 255;

    const max = Math.max(rn, gn, bn);
    const min = Math.min(rn, gn, bn);
    const delta = max - min;
    const lightness = (max + min) / 2;

    if (delta === 0) {
        return { h: 0, s: 0, l: Math.round(lightness * 100) };
    }

    const saturation = delta / (1 - Math.abs(2 * lightness - 1));

    let hue = 0;
    if (max === rn) {
        hue = ((gn - bn) / delta) % 6;
    } else if (max === gn) {
        hue = (bn - rn) / delta + 2;
    } else {
        hue = (rn - gn) / delta + 4;
    }

    hue = Math.round(hue * 60);
    if (hue < 0) hue += 360;

    return {
        h: hue,
        s: Math.round(saturation * 100),
        l: Math.round(lightness * 100),
    };
}

export function toHslSpaceSeparated(hex: string): string {
    const { r, g, b } = hexToRgb(hex);
    const { h, s, l } = rgbToHsl(r, g, b);
    return `${h} ${s} ${l}`;
}

export const AURORA_PRIMARY_GLOW_HSL = toHslSpaceSeparated(
    AURORA_COLOR_STOPS[0],
);
